import React from "react";
import { Field } from "redux-form";
import Tooltip from "@material-ui/core/Tooltip";
import COLORS from "../theme/colors";
import { MONTER_PALETTE, autoMonterColor, hasChosenColor } from "../theme/monterColors";

const styles = {
  wrap: { margin: "8px 0 12px" },
  label: { marginBottom: 8, color: COLORS.muted, fontSize: 13 },
  row: { display: "flex", flexWrap: "wrap", alignItems: "center" },
  swatch: {
    position: "relative",
    width: 34,
    height: 34,
    marginRight: 10,
    marginBottom: 8,
    padding: 0,
    border: "3px solid #fff",
    borderRadius: "50%",
    cursor: "pointer",
    outline: "none"
  },
  check: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    color: "#fff",
    fontSize: 16,
    fontWeight: 700,
    lineHeight: "28px",
    textAlign: "center"
  },
  auto: {
    display: "inline-flex",
    alignItems: "center",
    height: 34,
    marginRight: 10,
    marginBottom: 8,
    padding: "0 12px 0 6px",
    borderRadius: 17,
    border: `1px solid ${COLORS.border}`,
    backgroundColor: "#fff",
    color: COLORS.text,
    fontFamily: "inherit",
    fontSize: 13,
    cursor: "pointer"
  },
  autoDot: { width: 22, height: 22, marginRight: 8, borderRadius: "50%" },
  hint: { color: COLORS.muted, fontSize: 12 }
};

const Picker = ({ input, record }) => {
  const value = input.value;
  const chosen = hasChosenColor(value);
  const ring = selected => (selected ? `0 0 0 2px ${COLORS.text}` : `0 0 0 1px ${COLORS.border}`);

  return (
    <div style={styles.wrap}>
      <div style={styles.label}>Barva v koledarju</div>
      <div style={styles.row} role="radiogroup" aria-label="Barva v koledarju">
        <button
          type="button"
          role="radio"
          aria-checked={!chosen}
          onClick={() => input.onChange("")}
          style={{ ...styles.auto, boxShadow: !chosen ? `0 0 0 2px ${COLORS.text}` : "none" }}
        >
          <span style={{ ...styles.autoDot, backgroundColor: autoMonterColor(record && record.id) }} />
          Samodejno
        </button>
        {MONTER_PALETTE.map(color => {
          const selected = chosen && value.toLowerCase() === color.value;
          return (
            <Tooltip key={color.value} title={color.name}>
              <button
                type="button"
                role="radio"
                aria-checked={selected}
                aria-label={color.name}
                onClick={() => input.onChange(color.value)}
                style={{ ...styles.swatch, backgroundColor: color.value, boxShadow: ring(selected) }}
              >
                {selected && <span style={styles.check}>✓</span>}
              </button>
            </Tooltip>
          );
        })}
      </div>
      <div style={styles.hint}>Modra, zelena in siva so rezervirane za statuse nalogov.</div>
    </div>
  );
};

const ColorPickerInput = ({ source, record }) => (
  <Field name={source} component={Picker} record={record} />
);

export default ColorPickerInput;
